import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, AreaChart, Area, CartesianGrid } from 'recharts';

const CAT = { ssl: 'SSL', headers: 'HEADER', dns: 'DNS', mail: 'POSTA' };
const ST = [['ok', 'Ok', '#00FF87'], ['warn', 'Attenzione', '#FFB800'], ['bad', 'Critico', '#FF2E4D']];
const tip = { contentStyle: { background: '#0B0D13', border: '1px solid rgba(0,240,255,0.35)', fontSize: 12, fontFamily: 'JetBrains Mono' }, labelStyle: { color: '#00F0FF' }, itemStyle: { color: '#F0F4F8' } };
const tick = { fill: '#8A99AD', fontSize: 11, fontFamily: 'JetBrains Mono' };
const Empty = ({ t }) => <p className="h-[210px] grid place-items-center text-xs soc-mono soc-muted text-center px-4">{t}</p>;

function ChecksChart({ checks }) {
  const data = Object.entries(CAT).map(([k, name]) => ({ name, ...Object.fromEntries(ST.map(([s]) => [s, checks.filter((c) => c.category === k && c.status === s).length])) }));
  return (
    <ResponsiveContainer width="100%" height={210}>
      <BarChart data={data} margin={{ left: -24, right: 6, top: 6 }} barCategoryGap="28%">
        <CartesianGrid stroke="rgba(0,240,255,0.08)" strokeDasharray="3 4" vertical={false} />
        <XAxis dataKey="name" tick={tick} axisLine={{ stroke: 'rgba(0,240,255,0.2)' }} tickLine={false} />
        <YAxis allowDecimals={false} tick={tick} axisLine={false} tickLine={false} />
        <Tooltip {...tip} cursor={{ fill: 'rgba(0,240,255,0.05)' }} />
        {ST.map(([k, n, c]) => <Bar key={k} dataKey={k} name={n} stackId="a" fill={c} fillOpacity={0.85} stroke={c} />)}
      </BarChart>
    </ResponsiveContainer>
  );
}

function DevicesDonut({ devices }) {
  if (!devices.length) return <Empty t="NESSUN DEVICE CENSITO" />;
  const weak = devices.filter((d) => d.issues.length).length;
  const data = [{ name: 'Protetti', v: devices.length - weak, c: '#00FF87' }, { name: 'Vulnerabili', v: weak, c: '#FF2E4D' }];
  const pct = Math.round(((devices.length - weak) / devices.length) * 100);
  return (
    <div className="relative">
      <ResponsiveContainer width="100%" height={210}>
        <PieChart><Pie data={data} dataKey="v" nameKey="name" innerRadius={62} outerRadius={80} paddingAngle={4} stroke="none" startAngle={90} endAngle={-270}>{data.map((d) => <Cell key={d.name} fill={d.c} />)}</Pie><Tooltip {...tip} /></PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 grid place-items-center pointer-events-none"><div className="text-center"><p className="soc-mono text-2xl font-extrabold text-[#00FF87]">{pct}%</p><p className="soc-mono text-[10px] soc-muted">PROTETTI</p></div></div>
    </div>
  );
}

function Trend({ history }) {
  if (history.length < 2) return <Empty t="L'ANDAMENTO COMPARE DOPO LA SECONDA ANALISI" />;
  return (
    <ResponsiveContainer width="100%" height={210}>
      <AreaChart data={history} margin={{ left: -24, right: 6, top: 6 }}>
        <defs><linearGradient id="socArea" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#00F0FF" stopOpacity={0.45} /><stop offset="100%" stopColor="#00F0FF" stopOpacity={0} /></linearGradient></defs>
        <CartesianGrid stroke="rgba(0,240,255,0.08)" strokeDasharray="3 4" vertical={false} />
        <XAxis dataKey="date" tick={tick} axisLine={{ stroke: 'rgba(0,240,255,0.2)' }} tickLine={false} />
        <YAxis domain={[0, 100]} tick={tick} axisLine={false} tickLine={false} />
        <Tooltip {...tip} />
        <Area type="monotone" dataKey="score" name="Indice" stroke="#00F0FF" strokeWidth={2} fill="url(#socArea)" dot={{ r: 3, fill: '#0B0D13', stroke: '#00F0FF', strokeWidth: 2 }} />
      </AreaChart>
    </ResponsiveContainer>
  );
}

function Panel({ title, children, testid }) {
  return <div className="soc-card p-4" data-testid={testid}><p className="soc-title mb-3">{title}</p>{children}</div>;
}

export default function ConsoleCharts({ dom, devices }) {
  const checks = dom?.last?.checks || [];
  return (
    <div className="grid lg:grid-cols-3 gap-4 mt-4" data-testid="console-charts">
      <Panel title={`Controlli${dom ? ` · ${dom.domain}` : ''}`} testid="chart-checks">{checks.length ? <ChecksChart checks={checks} /> : <Empty t="NESSUNA ANALISI" />}
        <div className="flex gap-4 text-[10px] soc-mono soc-muted justify-center">{ST.map(([k, n, c]) => <span key={k} className="inline-flex items-center gap-1.5"><i className="w-2 h-2" style={{ background: c, boxShadow: `0 0 6px ${c}` }} />{n.toUpperCase()}</span>)}</div></Panel>
      <Panel title="Andamento indice" testid="chart-trend"><Trend history={dom?.history || []} /></Panel>
      <Panel title="Stato dei device" testid="chart-devices"><DevicesDonut devices={devices} /></Panel>
    </div>
  );
}
